module.exports = ".attach-account .custom-file {\n  overflow: hidden; }\n\n.attach-account .custom-file-control {\n  line-height: 28px; }\n\n.attach-account .custom-file-control:lang(en)::after {\n  content: '' !important; }\n\n.table-responsive {\n  height: 100%;\n  overflow: visible; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/attachment-account-client/attachment-account-client.component.scss
// module id = ./src/app/account-client/component/account-client-details/attachment-account-client/attachment-account-client.component.scss
// module chunks = main